import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { growthApi, ListParams } from '../api/growthApi'

// The server caches live Google Ads reads for 10 minutes; refetching sooner gains nothing.
const STALE = 5 * 60_000

export function useAccounts() {
  return useQuery({ queryKey: ['growth-accounts'], queryFn: growthApi.getAccounts, staleTime: STALE })
}

export function useOverview(customerId: string | undefined, days: number) {
  return useQuery({
    queryKey: ['growth-overview', customerId, days],
    queryFn: () => growthApi.getOverview(customerId!, days),
    enabled: !!customerId,
    placeholderData: keepPreviousData,
    staleTime: STALE,
  })
}

export function useCampaign(customerId: string | undefined, campaignId: string | undefined, days: number) {
  return useQuery({
    queryKey: ['growth-campaign', customerId, campaignId, days],
    queryFn: () => growthApi.getCampaign(customerId!, campaignId!, days),
    enabled: !!customerId && !!campaignId,
    placeholderData: keepPreviousData,
    staleTime: STALE,
  })
}

export function useSearchTerms(customerId: string | undefined, params: ListParams) {
  return useQuery({
    queryKey: ['growth-terms', customerId, params],
    queryFn: () => growthApi.getSearchTerms(customerId!, params),
    enabled: !!customerId,
    placeholderData: keepPreviousData,
    staleTime: STALE,
  })
}

export function useProducts(customerId: string | undefined, params: ListParams) {
  return useQuery({
    queryKey: ['growth-products', customerId, params],
    queryFn: () => growthApi.getProducts(customerId!, params),
    enabled: !!customerId,
    placeholderData: keepPreviousData,
    staleTime: STALE,
  })
}

export function useStrategy() {
  return useQuery({ queryKey: ['growth-strategy'], queryFn: growthApi.getStrategy, staleTime: STALE })
}
